module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    attrs: {
      "id": _vm.modalId,
      "title": _vm.title,
      "visible": _vm.show,
      "size": "lg",
      "no-close-on-backdrop": ""
    },
    on: {
      "ok": _vm.handleSubmit,
      "hidden": _vm.resetModal,
      "change": function (val) { return _vm.$emit('update:show', val); }
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('b-card', {
    staticClass: "dynamic-form-card shadow-lg animate__animated animate__fadeIn"
  }, [_c('b-card-body', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.handleSubmit($event)
      }
    }
  }, [_c('b-row', _vm._l((_vm.fields), function(field) {
    return _c('b-col', {
      key: field.name,
      staticClass: "mb-3",
      attrs: {
        "md": field.col || 6
      }
    }, [_c('b-form-group', {
      attrs: {
        "label": field.label,
        "label-for": field.name
      }
    }, [(field.type === 'text' || field.type === 'email' || field.type === 'password' || field.type === 'number') ? _c('b-form-input', {
      attrs: {
        "id": field.name,
        "type": field.type,
        "state": _vm.getValidationState(field.name)
      },
      on: {
        "blur": function($event) {
          _vm.$v.formData[field.name].$touch()
        }
      },
      model: {
        value: (_vm.formData[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.formData, field.name, (typeof $$v === 'string' ? $$v.trim() : $$v))
        },
        expression: "formData[field.name]"
      }
    }) : _vm._e(), _vm._v(" "), (field.type === 'select') ? _c('b-form-select', {
      attrs: {
        "id": field.name,
        "options": field.options,
        "state": _vm.getValidationState(field.name)
      },
      on: {
        "blur": function($event) {
          _vm.$v.formData[field.name].$touch()
        }
      },
      model: {
        value: (_vm.formData[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.formData, field.name, $$v)
        },
        expression: "formData[field.name]"
      }
    }) : _vm._e(), _vm._v(" "), (field.type === 'textarea') ? _c('b-form-textarea', {
      attrs: {
        "id": field.name,
        "state": _vm.getValidationState(field.name),
        "rows": "3"
      },
      on: {
        "blur": function($event) {
          _vm.$v.formData[field.name].$touch()
        }
      },
      model: {
        value: (_vm.formData[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.formData, field.name, $$v)
        },
        expression: "formData[field.name]"
      }
    }) : _vm._e(), _vm._v(" "), (field.type === 'date') ? _c('date-picker', {
      attrs: {
        "id": field.name,
        "valueType": "format",
        "format": field.format || 'YYYY-MM-DD',
        "input-class": ['form-control', {
          'is-invalid': _vm.getValidationState(field.name) === false
        }]
      },
      on: {
        "close": function($event) {
          _vm.$v.formData[field.name].$touch()
        }
      },
      model: {
        value: (_vm.formData[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.formData, field.name, $$v)
        },
        expression: "formData[field.name]"
      }
    }) : _vm._e(), _vm._v(" "), (field.type === 'daterange') ? _c('date-range-picker', {
      attrs: {
        "id": field.name,
        "input-class": ['form-control', {
          'is-invalid': _vm.getValidationState(field.name) === false
        }]
      },
      on: {
        "update": function($event) {
          _vm.$v.formData[field.name].$touch()
        }
      },
      model: {
        value: (_vm.formData[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.formData, field.name, $$v)
        },
        expression: "formData[field.name]"
      }
    }) : _vm._e(), _vm._v(" "), (field.type === 'search-select') ? _c('model-list-select', {
      class: {
        'is-invalid': _vm.getValidationState(field.name) === false
      },
      attrs: {
        "id": field.name,
        "list": field.options || [],
        "isDisabled": field.isDisabled || false,
        "option-value": field.optionValue || 'value',
        "option-text": field.optionText || 'text',
        "placeholder": field.placeholder || 'Select an item'
      },
      nativeOn: {
        "blur": function($event) {
          _vm.$v.formData[field.name].$touch()
        }
      },
      model: {
        value: (_vm.formData[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.formData, field.name, $$v)
        },
        expression: "formData[field.name]"
      }
    }) : _vm._e(), _vm._v(" "), (field.type === 'search-multi-select') ? _c('multi-select', {
      class: {
        'is-invalid': _vm.getValidationState(field.name) === false
      },
      attrs: {
        "id": field.name,
        "options": field.options || [],
        "selected-options": _vm.formData[field.name] || [],
        "placeholder": field.placeholder || 'Select items',
        "multiple": true
      },
      on: {
        "select": function (items) { return _vm.handleMultiSelect(items, field.name); }
      }
    }) : _vm._e(), _vm._v(" "), (field.type === 'multiselect' || field.type === 'tags') ? _c('multiselect', {
      class: {
        'is-invalid': _vm.getValidationState(field.name) === false
      },
      attrs: {
        "id": field.name,
        "options": field.options || [],
        "multiple": true,
        "taggable": field.type === 'tags',
        "placeholder": field.placeholder || 'Select options',
        "label": field.labelKey || 'label',
        "track-by": field.trackByKey || 'value'
      },
      on: {
        "tag": _vm.addTag,
        "close": function($event) {
          _vm.$v.formData[field.name].$touch()
        }
      },
      model: {
        value: (_vm.formData[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.formData, field.name, $$v)
        },
        expression: "formData[field.name]"
      }
    }) : _vm._e(), _vm._v(" "), (field.type === 'file') ? _c('b-form-file', {
      attrs: {
        "id": field.name,
        "state": _vm.getValidationState(field.name),
        "placeholder": field.placeholder || 'Choose a file or drop it here...',
        "drop-placeholder": "Drop file here..."
      },
      on: {
        "change": function($event) {
          _vm.$v.formData[field.name].$touch()
        }
      },
      model: {
        value: (_vm.formData[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.formData, field.name, $$v)
        },
        expression: "formData[field.name]"
      }
    }) : _vm._e(), _vm._v(" "), (field.type === 'color') ? _c('b-form-input', {
      staticClass: "w-100",
      attrs: {
        "id": field.name,
        "type": "color",
        "state": _vm.getValidationState(field.name)
      },
      on: {
        "blur": function($event) {
          _vm.$v.formData[field.name].$touch()
        }
      },
      model: {
        value: (_vm.formData[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.formData, field.name, $$v)
        },
        expression: "formData[field.name]"
      }
    }) : _vm._e(), _vm._v(" "), (field.type === 'range') ? _c('b-form-input', {
      attrs: {
        "id": field.name,
        "type": "range",
        "min": field.min || 0,
        "max": field.max || 100,
        "step": field.step || 1,
        "state": _vm.getValidationState(field.name)
      },
      on: {
        "change": function($event) {
          _vm.$v.formData[field.name].$touch()
        }
      },
      model: {
        value: (_vm.formData[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.formData, field.name, $$v)
        },
        expression: "formData[field.name]"
      }
    }) : _vm._e(), _vm._v(" "), (field.type === 'checkbox') ? _c('b-form-checkbox', {
      attrs: {
        "id": field.name,
        "state": _vm.getValidationState(field.name)
      },
      on: {
        "blur": function($event) {
          _vm.$v.formData[field.name].$touch()
        }
      },
      model: {
        value: (_vm.formData[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.formData, field.name, $$v)
        },
        expression: "formData[field.name]"
      }
    }, [_vm._v("\n                  " + _vm._s(field.checkboxLabel || '') + "\n                ")]) : _vm._e(), _vm._v(" "), (field.type === 'checkbox-group') ? _c('b-form-checkbox-group', {
      attrs: {
        "id": field.name,
        "options": field.options,
        "state": _vm.getValidationState(field.name)
      },
      on: {
        "blur": function($event) {
          _vm.$v.formData[field.name].$touch()
        }
      },
      model: {
        value: (_vm.formData[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.formData, field.name, $$v)
        },
        expression: "formData[field.name]"
      }
    }) : _vm._e(), _vm._v(" "), (field.type === 'radio') ? _c('b-form-radio-group', {
      attrs: {
        "id": field.name,
        "options": field.options,
        "state": _vm.getValidationState(field.name)
      },
      on: {
        "blur": function($event) {
          _vm.$v.formData[field.name].$touch()
        }
      },
      model: {
        value: (_vm.formData[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.formData, field.name, $$v)
        },
        expression: "formData[field.name]"
      }
    }) : _vm._e(), _vm._v(" "), (_vm.$v.formData[field.name] && _vm.$v.formData[field.name].$error) ? _c('div', {
      staticClass: "invalid-feedback"
    }, [(!_vm.$v.formData[field.name].required) ? _c('span', [_vm._v("This field is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.formData[field.name].email) ? _c('span', [_vm._v("Please enter a valid email address.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.formData[field.name].minLength) ? _c('span', [_vm._v("Must have at least " + _vm._s(_vm.$v.formData[field.name].$params.minLength.min) + " letters.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.formData[field.name].maxLength) ? _c('span', [_vm._v("Can have at most " + _vm._s(_vm.$v.formData[field.name].$params.maxLength.max) + " letters.")]) : _vm._e()]) : _vm._e()], 1)], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-end mt-4"
  }, [_c('b-button', {
    staticClass: "px-5 py-2 shadow-sm",
    attrs: {
      "type": "submit",
      "variant": "primary",
      "size": "lg",
      "disabled": _vm.$v.$invalid
    }
  }, [_vm._v("\n              Submit\n            ")])], 1)], 1)])], 1)], 1), _vm._v(" "), [_c('b-button', {
    on: {
      "click": function($event) {
        _vm.cancel()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "primary",
      "disabled": _vm.$v.$invalid
    },
    on: {
      "click": function($event) {
        _vm.ok()
      }
    }
  }, [_vm._v("\n      Submit\n    ")])]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-536de19a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/allModuleForm/commonModal.vue
// module id = 2632
// module chunks = 0